import React from 'react';
import PropTypes from 'prop-types';

import applySkeleton from '../../../hocs/applySkeleton';
import Icon from '../../Icon';

const MainContent = ({ mainContent = '', icon, theme }) => {
    const iconResolved = icon && icon.name === null ? null : icon;

    return (
        <div className={ theme.mainContent }>
            { iconResolved && (
                <div className={ theme.iconWrapper }>
                    {icon.name && <Icon name={ icon.name } className={ icon.className } theme={ theme } />}
                    {icon.component && icon.component}
                </div>
            )}
            <div className={ theme.text }>
                {mainContent}
            </div>
        </div>
    );
};

MainContent.propTypes = {
    mainContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    icon: PropTypes.shape({
        name: PropTypes.string,
        component: PropTypes.element,
        className: PropTypes.string,
    }),
    theme: PropTypes.shape({}),
};

export default applySkeleton(MainContent);
